import React from 'react';

export const Header: React.FC = () => {
  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-baseline">
          <div className="text-3xl font-bold">
            <span className="text-yellow-500">Peritajes</span><span className="text-blue-600">.EU</span>
          </div>
          <span className="ml-2 text-xl font-medium text-blue-500">
            (con Multas<span className="text-yellow-500">.EU</span> y Juzgados<span className="text-yellow-500">.EU</span>)
          </span>
        </div>
      </div>
    </header>
  );
};